import Vue from "vue";
import Mui from "vue-awesome-mui";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import { createPinia, PiniaVuePlugin } from "pinia";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/style/common.css";
import "@/assets/style/element/index.css";
import "@/assets/icon/iconfont.css";

import "@/assets/style/element.less";
import "mint-ui/lib/style.css";
import piniaPluginPersist from "pinia-plugin-persist";
import enLocale from "element-ui/lib/locale/lang/en";
import i18n from "@/locales";
import MyBack from "@/components/MyBack.vue";
import MyLoading from "@/components/MyLoading.vue";
import { myMessage } from "@/utils/message";
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.use(ElementUI, { locale: enLocale });

Vue.use(PiniaVuePlugin);
Vue.use(ElementUI);
Vue.component("my-back", MyBack);
Vue.component("my-loading", MyLoading);
const pinia = createPinia();

pinia.use(piniaPluginPersist);

// 注册全局方法
Vue.prototype.$displayObjectName = function(obj) {
  if (obj.hasOwnProperty("name") && obj.name !== null && obj.name !== "") {
    return obj.name;
  } else {
    return obj.name_en;
  }
};

// 添加公共方法
Vue.prototype.$myMessage = myMessage;

Vue.use(Mui);
new Vue({
  i18n,
  router,
  pinia,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js